import { ImgID } from "../../../image_loader/img_id.js";
import { Easing } from "../../../transforms/transform_base.js";
import { TransformRotate } from "../../../transforms/transform_rotate.js";
import { UIImage } from "../../common_ui_elements/ui_image.js";
import { UIElement } from "../../common_ui_elements/ui_element.js";

export class Spinner extends UIElement
{
  private static readonly DEFAULT_ROTATION_DURATION_MS = 2000;

  private rotation_duration_ms: number = Spinner.DEFAULT_ROTATION_DURATION_MS;
  private is_spinning: boolean = false;

  constructor( ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number )
  {
    super( ctx, x, y, width, height );

    const spinner_image = new UIImage(
      this.ctx,
      0,
      0,
      width,
      height,
      ImgID.UI_LeaderboardSpinner,
    );
    this.addChild( spinner_image, true );

    this.enableRotation();
    this.start();
  }

  public start(): void
  {
    if ( this.is_spinning ) return;

    this.is_spinning = true;
    this.addTransform( new TransformRotate(
      this,
      true,
      null,
      this.getRotationImportant() - Math.PI * 2,
      performance.now(),
      this.rotation_duration_ms,
      {
        infinite_loop: true,
        easing: Easing.Linear,
      }
    ) );
    this.forceRedraw();
  }

  public stop(): void
  {
    if ( !this.is_spinning ) return;

    this.is_spinning = false;
    this.stopAllTransforms();
    this.forceRedraw();
  }

  public setRotationDuration( ms: number ): void
  {
    this.rotation_duration_ms = Math.max( 1, Math.floor( ms ) );

    if ( this.is_spinning )
    {
      this.stop();
      this.start();
    }
  }

  public isSpinning(): boolean
  {
    return this.is_spinning;
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() ) return;

    this.startRender();
    this.finishRender();
  }

  public name(): string
  {
    return "Spinner";
  }
}